/* eslint-disable react/prop-types */ // TODO: add props
import urlResolver from 'edrolo/utils/URLResolver';
import AppContainer from 'edrolo/domains/app/components/AppContainer';

const QuestionSetBreadcrumbs = ({
  classId,
  exam,
  isTeacher,
  examTitleIsLink,
  isDemo,
  isEmInsights,
}) => {
  const rootCrumb = (
    <AppContainer.Crumb
      url={urlResolver.reverse('courses-page')}
      anchor
      disable={isDemo}
    >
      My subjects
    </AppContainer.Crumb>
  );

  if (!exam) {
    return <AppContainer.Breadcrumbs>{rootCrumb}</AppContainer.Breadcrumbs>;
  } // exam is not loaded

  const topicId = exam.getIn(['topic', 'id']);
  const topicPageUrl = urlResolver.reverse('topic-page', {
    classId,
    topicId,
  });
  const coursePageUrl = urlResolver.reverse('course-page', {
    classId,
  });

  return (
    <AppContainer.Breadcrumbs>
      {rootCrumb}

      <AppContainer.Crumb url={coursePageUrl} disable={isDemo}>
        {exam.get('course_title')}
      </AppContainer.Crumb>

      <AppContainer.Crumb url={topicPageUrl} disable={isDemo}>
        {exam.getIn(['topic', 'title'])}
      </AppContainer.Crumb>

      {!isEmInsights && (
        <AppContainer.Crumb
          url={
            examTitleIsLink
              ? urlResolver.reverse('question-set-index', {
                  classId,
                  examId: exam.get('id'),
                })
              : null
          }
          disable={isDemo}
        >
          {exam.get('title', '')}
        </AppContainer.Crumb>
      )}

      {isEmInsights && (
        <>
          <AppContainer.Crumb
            url={
              urlResolver.reverse('topic-page', {
                classId,
                topicId,
              }) + `#${exam.get('id')}`
            }
          >
            {exam.get('title')}
          </AppContainer.Crumb>
          <AppContainer.Crumb
            url={urlResolver.reverse('em-insights-page', {
              classId,
              topicId,
              examId: exam.get('id'),
            })}
          >
            {'Insights'}
          </AppContainer.Crumb>
        </>
      )}
    </AppContainer.Breadcrumbs>
  );
};

export const QuestionSetTopBar = ({
  classId,
  exam,
  isTeacher,
  examTitleIsLink,
  isDemo,
  isEmInsights,
}) => (
  <AppContainer.FullTopBar>
    <AppContainer.EdroloLogo />
    <QuestionSetBreadcrumbs
      isTeacher={isTeacher}
      classId={classId}
      exam={exam}
      examTitleIsLink={examTitleIsLink}
      isDemo={isDemo}
      isEmInsights={isEmInsights}
    />
    <AppContainer.ProfileNav />
  </AppContainer.FullTopBar>
);
